import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAsn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={14}
    fill="currentColor"
    {...props}
  >
    <path d="M5.812 0a1.666 1.666 0 0 1 1.32 2.679L7.88 4.27a3.76 3.76 0 0 1 3.424.87l2.06-1.563a1.666 1.666 0 1 1 .866 1.226l-2.04 1.55a3.74 3.74 0 0 1 .156 2.728l1.86 1.129a1.666 1.666 0 1 1-.846 1.242l-1.758-1.067a3.74 3.74 0 0 1-2.823 1.284 3.754 3.754 0 0 1-3.665-2.944l-2.012.032A1.663 1.663 0 0 1 0 7.916a1.666 1.666 0 0 1 3.195-.661l1.895-.03a3.75 3.75 0 0 1 1.435-2.31L5.781 3.33A1.665 1.665 0 0 1 5.811 0Zm2.967 5.663a2.253 2.253 0 1 0 0 4.506 2.253 2.253 0 0 0 0-4.506" />
  </svg>
);
export default SvgAsn;
